<script lang="ts" setup>
import { useRuntimeConfig } from '#app'
import { AuthTabEnum, RoutesEnum } from '~/enums'
import { DEPOSIT_METHOD_MENUS } from '~/resources/account'
import { REGISTER_INSTRUCTION } from '~/resources/instruction'
import { FOOTER_MENUS } from '~/resources/menus'

defineProps({
  isShowSidebar: {
    type: Boolean,
    default: false,
  },
})
const { BRAND_NAME, COPYRIGHT_YEAR } = useRuntimeConfig().public
const { navigate } = useNavigate()
const { openAuthModal } = useAuth()
const authStore = useAuthStore()
const { isLogged } = useUser()
const { isOpenInstruction, toggleInstruction } = useInstruction()
const { isMaintenance, fetchDepositEWalletsData } = useDepositData()

const openModalWithRegister = () => {
  authStore.setSelectedAuthTab(AuthTabEnum.Register)
  openAuthModal()
}

onMounted(() => {
  if (isLogged.value) {
    fetchDepositEWalletsData()
  }
})

watch(
  () => isLogged.value,
  (value) => {
    if (value) {
      fetchDepositEWalletsData()
    }
  },
)
</script>
<template>
  <footer class="footer">
    <div class="layout__container">
      <div v-if="isShowSidebar" class="layout__sidebar" />
      <div class="background-top-footer" />
      <div class="layout__content pt-0">
        <div class="content-page">
          <div class="footer__wrapper">
            <div class="container">
              <div class="footer-top">
                <div class="wrapper-logo">
                  <img
                    class="footer-top__logo"
                    src="/images/logo/logo.svg"
                    alt="Footer Logo"
                    width="130"
                    height="48"
                    loading="lazy"
                  />
                  <div class="footer-top__desc-brand">
                    <span class="footer-top__desc-brand__name">{{
                      BRAND_NAME
                    }}</span>
                    là nhà cái uy tín hàng đầu Châu Âu, cung cấp các sản phẩm cá
                    cược đa dạng như: Thể thao, E-Sports, Casino trực tuyến, Lô
                    đề và Game Slot cùng nhiều...
                    <NuxtLink
                      class="footer-top__desc-brand__more-link"
                      :to="RoutesEnum.About"
                      >Xem thêm</NuxtLink
                    >
                  </div>
                </div>
                <div class="footer-top__reserved">
                  <img
                    class="footer-top__reserved-logo"
                    src="/images/footer/logo_right.webp"
                    alt="Right Reserved"
                    width="190"
                    height="48"
                    loading="lazy"
                  />
                  <div class="footer-top__reserved-text">
                    ©{{ COPYRIGHT_YEAR }} {{ BRAND_NAME }}. All rights reserved
                  </div>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="footer-row">
                <div
                  v-for="(item, index) in FOOTER_MENUS(BRAND_NAME)"
                  :key="index"
                  class="footer-col"
                >
                  <div class="footer-menu">
                    <h3 class="footer-menu__name">{{ item.title }}</h3>
                    <ul class="nav-menu">
                      <li
                        v-for="sub in item.menus"
                        :key="sub.to"
                        class="nav-menu__item"
                      >
                        <template v-if="sub.to === RoutesEnum.InstructRegister">
                          <div
                            class="menu-link cursor-pointer"
                            @click="toggleInstruction()"
                          >
                            {{ sub.title }}
                          </div>
                        </template>
                        <template v-else>
                          <NuxtLink class="menu-link" :to="sub.to">
                            {{ sub.title }}
                          </NuxtLink>
                        </template>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="footer-col">
                  <div class="footer-menu">
                    <h3 class="footer-menu__name">Phương thức thanh toán</h3>
                    <div class="deposit-method">
                      <a
                        v-for="method in DEPOSIT_METHOD_MENUS"
                        :key="method.to"
                        class="deposit-method__item"
                        :class="{
                          'deposit-method__item--maintain':
                            isLogged && isMaintenance(method.method),
                        }"
                        :href="method.to"
                        @click.prevent="navigate(method.to, true)"
                      >
                        <img
                          class="deposit-method__image"
                          :src="method.image"
                          :alt="`Icon ${method.title}`"
                          width="24"
                          height="24"
                          loading="lazy"
                        />
                        <div class="deposit-method__name">
                          {{ method.title }}
                        </div>
                        <div
                          v-if="isLogged && isMaintenance(method.method)"
                          class="label-maintenance"
                        >
                          <span>Bảo trì</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalCommonInstruction
      v-model="isOpenInstruction"
      :disable-final="isLogged"
      :data="REGISTER_INSTRUCTION"
      :on-finished="openModalWithRegister"
      final-step-label="Đăng ký"
    />
  </footer>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/footer/index.scss';
@import '~/assets/styles/components/responsive/desktop/footer/index.scss';
</style>
